import { Menu, Group, rem, Text } from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"
import React, { ReactElement } from "react"

import { Button, ButtonProps } from "../../../atoms/Button/Button"

export type ButtonWithMenuProps = {
  children?: React.ReactNode
  icon?: React.ReactNode
  items: {
    icon?: ReactElement
    label: string
    onClick?: () => void
    disabled?: boolean
  }[]
  loading?: boolean
  iconStyles?: React.CSSProperties
  dropDownWidth?: string | number
} & React.ComponentProps<typeof Button> &
  React.ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonProps

const defaultIconStyle = {
  width: 16,
  height: 16,
  color: "var(--mantine-color-primary-4)",
}

export const ButtonWithMenu = ({
  children,
  items,
  icon: _icon,
  loading,
  iconStyles = {},
  dropDownWidth,
  ...props
}: ButtonWithMenuProps) => {
  return (
    <Group wrap="nowrap" gap={0}>
      <Menu
        transitionProps={{ transition: "pop-top-right" }}
        width={220}
        withinPortal
      >
        <Menu.Target>
          <Button
            rightSection={
              <IconChevronDown
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
              />
            }
            loading={loading}
            loaderProps={{ type: "dots" }}
            pr={12}
            {...props}
          >
            {children}
          </Button>
        </Menu.Target>
        {items && (
          <Menu.Dropdown w={dropDownWidth}>
            {items.map(({ icon, label, onClick, disabled }, index) => (
              <Menu.Item
                key={index}
                leftSection={
                  icon &&
                  React.cloneElement(icon, {
                    ...defaultIconStyle,
                    ...iconStyles,
                  })
                }
                onClick={onClick}
                disabled={disabled}
              >
                <Text size="sm">{label}</Text>
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        )}
      </Menu>
    </Group>
  )
}
